import type { FaireProductEntity } from "../../entity_types/product";

export const p_65m9dfxfbu: FaireProductEntity = {
  token: "p_65m9dfxfbu",
  type: "product",
  name: 'Gold Knot Cocktail Pick-5"L',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/7b1c64bf748810358ebb66d5dcddeb1c8b42bc7cd632766d60c6fd7b2ae8491e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8179861d7b9b97a44f3a92e8025a42a47f20b572329273c337d56a7db4fe43f8.jpeg",
    "https://cdn.faire.com/fastly/af8460b7a88caf130296ac8c7978c8fe09ef827f3da0e624366ad822ace37311.jpeg",
  ],
  priceDollars: 2.5,
  description:
    "Introducing our Gold Knot Cocktail Pick. Perfect for adding a touch of sophistication to your drinks, this elegant pick features a beautifully crafted knot design at the top. Durable and stylish, it's ideal for garnishing cocktails or serving appetizers, making it a must-have accessory for any entertaining occasion. Handcrafted in India",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:09.815Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
